import { render, staticRenderFns } from "./LayoutXml.vue?vue&type=template&id=21dd8c74"
import script from "./LayoutXml.vue?vue&type=script&lang=js"
export * from "./LayoutXml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports